<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    :options="form.tipos"
                    :validations="validations.tipo"
                    label="Tipo"
                    show-default-option
                    text-field="nome"
                    v-model="model.tipoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-multiselect
                    :options="form.unidades"
                    :select-limit="null"
                    @update:dropdownClosed="handleUnidadeClosed"
                    label="Unidades"
                    option-name-key="nome"
                    option-text-selecteds="unidade selecionado"
                    v-model="model.unidades"
                    value-field="id"
                />
            </rkm-col>

             <rkm-col cols="4">
                <rkm-form-multiselect
                    :options="form.infraestruturas"
                    :select-limit="null"
                    @update:dropdownClosed="handleInfraestruturaClosed"
                    label="Local de atendimento"
                    option-name-key="nome"
                    option-text-selecteds="local selecionado"
                    v-model="model.infraestruturas"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-multiselect
                    :options="form.usuarios"
                    :select-limit="null"
                    label="Usuários"
                    option-name-key="nome"
                    option-text-selecteds="usuário selecionado"
                    v-model="model.usuarios"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="8">
                <rkm-form-input
                    :validations="validations.titulo"
                    label="Título"
                    v-model="model.titulo"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-text-editor
                    :validations="validations.mensagem"
                    label="Mensagem"
                    v-model="model.mensagem"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, object, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                tipo: {required: true},
                titulo: {
                    required: true,
                    min: 3,
                    max: 200,
                },
                mensagem: {
                    required: true,
                    min: 3,
                    max: 5000,
                },
            }
        }
    },
    created() {
        this.repositories = {
            notificacao: this.getConectaSusRepository('administracao.notificacao')
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.notificacao.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            } else {
                this.repositories.notificacao.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleUnidadeClosed() {
            const request = {
                listar: 'infraestruturas',
                unidades: this.model.unidades,
            }

            this.setLoading()

            this.repositories.notificacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaClosed() {
            const request = {
                listar: 'usuarios',
                infraestruturas: this.model.infraestruturas,
            }

            this.setLoading()

            this.repositories.notificacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const request = {
                        tipoId: this.model.tipoId,
                        infraestruturas: this.model.infraestruturas,
                        usuarios: this.model.usuarios,
                        titulo: this.model.titulo,
                        mensagem: this.model.mensagem,
                    }

                    this.setLoading()

                    if (this.model.id) {
                        this.repositories.notificacao.update(this.model.id, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.notificacao.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [error, object, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>